import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';
import { getEnv } from '../../AppConfigs';
import { getStartDayOfWeek, setUtcWithoutTime, getEndDayOfMonth, getStartDayOfMonth, getDay } from '../../helper/dateTimeHelper';

const SPSiteId = getEnv('REACT_APP_SP_SITE_ID');
const SPListId = getEnv('REACT_APP_MEETING_TEMPLATE_SP_LIST_ID');

export class EventsService {
  static async getEvents(filterBy?: string) {
    let url = "/me/events";
    switch (filterBy) {
      case 'today':
        const today = getDay();
        url = url + `?$filter=start/dateTime ge '${setUtcWithoutTime(today)}' and end/dateTime le '${setUtcWithoutTime(today.add(1, 'day'))}'`
        break;
      case 'thisweek':
        const startw = getStartDayOfWeek();
        const endw = startw.add(6, 'day');
        url = url + `?$filter=start/dateTime ge '${setUtcWithoutTime(startw)}' and end/dateTime le '${setUtcWithoutTime(endw)}'`
        break;
      case 'thismonth':
        const startm = getStartDayOfMonth();
        const endm = getEndDayOfMonth();
        url = url + `?$filter=start/dateTime ge '${setUtcWithoutTime(startm)}' and end/dateTime le '${setUtcWithoutTime(endm)}'`
        break;
      default:
        break;
    }
    url = url + '&$orderby=start/dateTime desc'
    return api.get(getURL(url))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }

  static async getEventById(id: string) {
    return api.get(getURL(`/me/events/${id}`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async addEvent(event: any) {
    return api.post(getURL("/me/calendar/events"), event)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async updateEvent(event: any) {
    return api.patch(getURL(`/me/calendar/events/${event.id}`), event)
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async cancelEvent(id: any) {
    return api.post(getURL(`/me/calendar/events/${id}/cancel`))
      .then(res => res.data)
      .catch(err => { throw new RequestError(err) });
  }

  static async getEventsTemplate() {
    return api.get(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items?expand=fields(select=title,eContent)`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }
}